import { render, staticRenderFns } from "./ReactionIcon.vue?vue&type=template&id=27b26f32&scoped=true&"
import script from "./ReactionIcon.vue?vue&type=script&lang=ts&"
export * from "./ReactionIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b26f32",
  null
  
)

export default component.exports